<template>
  <div class="box" @click="toSearch">
    <div class="img" alt="" srcset="" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    toSearch() {
      this.$router.push({ name: "inspiectSearch" });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background: linear-gradient(180deg, #0045b3 0%, #0062ff 100%), #fff;
  background-size: 100% 350px, 100% 100%;
  background-repeat: no-repeat;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  min-width: 1130px;
  padding-bottom: 80px;
  .img {
    width: 1130px;
    height: 616px;
    background-image: url("~@/assets/image/fengxianpaicha/bg.webp");  // 带有透明度的图片
    background-size: cover;
  }
}
</style>
